<template>
  <div class="forget-wrapper">
    <div class="reset-password">Reset Password</div>
    <div class="email-text">
      Enter your email address and we'll email you a link to reset your password
    </div>
    <v-text-field
      v-model="emailAddress"
      label="Email Address"
      required
      style="margin: 20px 0"
      outlined
      dense
      @blur="$v.emailAddress.$touch()"
      :error-messages="validationErrors('email', $v.emailAddress)"
      @keyup.enter="resetUserPassword"
    />
    <div class="btn-styling">
      <Button
        label="Go Back"
        size="large"
        buttonColor="#fff"
        fontColor="#202124"
        @click="$router.go(-1)"
        :outlined="true"
        style="margin-right: 10px"
      />
      <Button
        label="Send Link"
        size="large"
        buttonColor="#128279"
        fontColor="#ffffff"
        @click="resetUserPassword"
        style="margin-left: 10px"
      />
    </div>
    <progress-loader v-if="loading" />
    <snack-bar
      :snackbar="snackbar"
      :snackbarMsg="message"
      iconName="fa-regular fa-check"
      :isSuccess="isSuccess"
    />
  </div>
</template>

<script>
import { Button, Utils } from '@ciitizen/component-library'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'forget-password',
  data() {
    return {
      emailAddress: '',
      loading: false,
      message: '',
      snackbar: false,
      isSuccess: false
    }
  },
  validations() {
    return {
      emailAddress: { required, email }
    }
  },
  components: {
    Button
  },
  methods: {
    ...mapActions(['resetPassword']),
    async resetUserPassword() {
      try {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.loading = true
        let payload = {
          email: this.emailAddress.trim()
        }
        Utils.callSegmentTrack({ name: 'pp.forget_password.submitted' })
        const response = await this.resetPassword(payload)
        Utils.callSegmentTrack({ name: 'pp.forget_password.success' })
        this.isSuccess = true
        this.message = response
        this.showSnakeBar()
      } catch (e) {
        Utils.callSegmentTrack({ name: 'pp.forget_password.failed' })
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    showSnakeBar() {
      this.snackbar = true
      setTimeout(() => {
        this.snackbar = false
      }, 3000)
    },
    validationErrors(name, model) {
      const errors = []
      if (!model.$dirty) return errors
      switch (name) {
        case 'email':
          !model.required && errors.push('Email is required')
          !model.email && errors.push('Please enter a valid email')
          break
        default:
          break
      }
      return errors
    }
  }
}
</script>

<style lang="stylus" scoped>
.reset-password
  font-size: 18px
  font-weight: 600
  letter-spacing: normal
  line-height:2rem
  color: #161616

.email-text
  font-size: 16px
  font-weight: 400
  letter-spacing: normal
  line-height:2rem
  color: #161616
  margin-top: 10px

.btn-height-large
  width: 130px !important

.btn-styling
 display: flex
 justify-content: space-between
 margin-bottom: 40px

@media only screen and (max-width: 561px)
 .forget-wrapper
  margin-top: 40px
</style>
